import {
  LocationDto,
  LocationPageDto,
} from "../../../types/location/location-dto";
import { convertLocationDtoToLocation } from "../../../utils/converter/location/location-converter";
import { LocationState } from "../../type/location-state";

interface Action {
  type: string;
  payload: {
    locationPageDto: LocationPageDto;
  };
}

export const setLocationPageDispatch = (
  state: LocationState,
  action: Action
) => {
  const { locationPageDto } = action.payload;
  state.locationPage = {
    contents: locationPageDto.contents.map((locationDto: LocationDto) => {
      return convertLocationDtoToLocation(locationDto);
    }),
    first: locationPageDto.first,
    last: locationPageDto.last,
    page: locationPageDto.page,
    totalPages: locationPageDto.totalPages,
    totalElements: locationPageDto.totalElements,
  };
};
